<template>
  <v-dialog
    id="nav-signout-dialog"
    v-model="isOpen"
    width="300px"
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-icon class='mr-2'>exit_to_app</v-icon>
        <v-list-item-title>
          Sign Out
        </v-list-item-title>
      </v-list-item>
    </template>

    <v-card>
      <v-card-title 
        class="headline grey lighten-2" 
        primary-title
      >
        Sign Out
      </v-card-title>
      <v-card-text> Are you sure you want to sign out? </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn 
          @click="handleSignout"
          color="primary" 
          text 
        >
          Sign Out
        </v-btn>
        <v-btn 
          @click="isOpen = false"
          color="primary" 
          text       
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SignoutDialog",
  props: [
    "SignOut",
    "closeProfileList"
  ],
  data() {
    return {
      isOpen: false
    }
  },
  watch: {
    isOpen() {
      this.closeProfileList()
    }
  },
  methods: {
    // sign out of firebase and close modal
    handleSignout() {
      this.SignOut()
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
#nav-signout-dialog {
  width: 300px;
}
</style>